import React from 'react';
import ReactDOM from 'react-dom/client';
import AppPwa from './pwa/AppPwa.jsx';
import AppLine from './line/AppLine.jsx';
import AppWeb from './web/AppWeb.jsx';
import AppAdmin from './admin/AppAdmin.jsx';
import PwaInstallPage from './web/pwaInstallPage.jsx';
import ErrorBoundary from './shared/components/ErrorBoundary.jsx'; // ★追加

// import { initHud, hudLog } from './shared/utils/hud'; 

// --- PWA: ルート起動の保険リダイレクト（スタンドアロン時のみ） ---
(function guardPwaRootRedirect() {
  try {
    const path = window.location.pathname || '/';
    const isRoot = path === '/' || path === '/index.html';
    const isStandalone =
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      (typeof navigator !== 'undefined' && navigator.standalone === true); // iOS Safari

    // ホームアイコンから「ルート」で起動した PWA は /pwa/ に寄せる
    if (isRoot && isStandalone) {
      const rootEl = document.getElementById('root');
      if (rootEl) {
        // ちらつき防止のプレースホルダーを描画（Reactはまだ起動しない）
        rootEl.innerHTML = `
          <div class="boot-loading">
            <div class="boot-spinner"></div>
            <div class="boot-text">起動しています…</div>
          </div>`;
      }
      // 即時リダイレクト（履歴を汚さない）
      window.location.replace('/pwa/');
      // ここで関数を抜けるだけ（React の render は呼ばれない）
    }
  } catch (_) {}
})();
// ==== 追加ここまで ====

// （お好みで）ローディングの簡単なスタイル
const style = document.createElement('style');
style.textContent = `
  .boot-loading {min-height:100vh;display:grid;place-items:center;font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;color:#374151}
  .boot-spinner{width:36px;height:36px;border:3px solid #d1d5db;border-top-color:#56BB37;border-radius:50%;animation:spin 0.9s linear infinite;margin-inline:auto;margin-bottom:10px}
  .boot-text{font-size:14px;color:#6b7280}
  @keyframes spin{to{transform:rotate(360deg)}}
`;
document.head.appendChild(style);

// デバイス判定
const isMobile = /iPhone|Android|iPad|iPod|Mobile/i.test(navigator.userAgent);
const path = window.location.pathname;

let App;

if (path.startsWith('/line')) {

    App = AppLine;
    // if (isMobile) {
    //     App = AppLine;
    // } else {
    //     window.location.href = 'https://kitamura.clinic';
    // }
} else if (path.startsWith('/pwa')) {

    App = AppPwa;
    // if (isMobile) {
    //     App = AppPwa;
    // } else {
    //     window.location.href = 'https://kitamura.clinic';
    // }


} else if (path.startsWith('/web')) {
    App = AppWeb;            

} else if (path.startsWith('/admin')) {
  
  App = AppAdmin;

} else {
    // それ以外（Webサイトトップなど）
    App = () => <PwaInstallPage />;
    //   if (isMobile) {
    //     App = () => <PwaInstallPage />;
    //   } else {
    //     window.location.href = 'https://kitamura.clinic';
    //   }
}
// HUD を初期化（最大300行・初期表示は ?hud=1 or localStorage 次第）
// const HUD = initHud({ maxLines: 300 });
// hudLog('boot', { path: window.location.pathname });

// 画面に出るグローバル例外ログ
window.addEventListener('error', (e) => {
  try { window.__HUD__?.log?.('[window.error]', String(e?.error?.stack || e?.message || e)); } catch {}
});
window.addEventListener('unhandledrejection', (e) => {
  try { window.__HUD__?.log?.('[unhandledrejection]', String(e?.reason?.stack || e?.reason || e)); } catch {}
});

if (App) {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
}
